/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fileName: NonNullable<unknown> }} Coinvestments_Dataroom_Removeuploaditem4Inputs */

const en_coinvestments_dataroom_removeuploaditem4 = /** @type {(inputs: Coinvestments_Dataroom_Removeuploaditem4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.fileName}`)
};

/**
* | output |
* | --- |
* | "Remove {fileName}" |
*
* @param {Coinvestments_Dataroom_Removeuploaditem4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_removeuploaditem4 = /** @type {((inputs: Coinvestments_Dataroom_Removeuploaditem4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Removeuploaditem4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_removeuploaditem4(inputs)
});
export { coinvestments_dataroom_removeuploaditem4 as "coInvestments_dataRoom_removeUploadItem" }